import axios from "axios";
import { Response } from "@/types/response-type";
import { Withholding } from "@/types/withholding";
const API_URL = process.env.VUE_APP_BASE_URL;

export const client_withholding_tax_service = async (
  form: Withholding
): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      responseType: "blob",
      url: `${API_URL}/client_withholding_tax`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    const content = response.headers["content-type"];
    if (response.status === 400 && content !== "application/pdf") {
      const response_text: string = await response.data.text();
      const response_obj = JSON.parse(response_text);
      throw new Error(`${response_obj.message}`);
    }
    return {
      status: response.status,
      message: `Generando pdf`,
      data: response.data,
    } as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};

export const client_withholding_ica_service = async (
  form: Withholding
): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      responseType: "blob",
      url: `${API_URL}/client_withholding_ica`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    const content = response.headers["content-type"];
    if (response.status === 400 && content !== "application/pdf") {
      const response_text: string = await response.data.text();
      const response_obj = JSON.parse(response_text);
      throw new Error(`${response_obj.message}`);
    }
    return {
      status: response.status,
      message: `Generando pdf`,
      data: response.data,
    } as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};
